module.exports = __webpack_public_path__ + "static/media/cover_kwal_onder.b5462633.png";